<ngx-spinner bdColor="var(--app-color-spinner-backdrop)" type="ball-climbing-dot">
  <app-text color="white">{{loaderText()}}</app-text>
</ngx-spinner>

<app-shell>
  @if (!isPageBootstrapping() && siteTheme.isReady()) {
    <router-outlet></router-outlet>
  }
</app-shell>

@if (showCookies() === true && pageContents().get('lbl_HTML_Cookies')) {
  <div id="divCookies" [innerHTML]="pageContents().get('lbl_HTML_Cookies') | safeHtml"></div>
}